import { render, staticRenderFns } from "./tired_limit_speed_set.vue?vue&type=template&id=c3cfd51e&scoped=true"
import script from "./tired_limit_speed_set.vue?vue&type=script&lang=js"
export * from "./tired_limit_speed_set.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_77a37368fa9f7d737cecfb85aa182826/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3cfd51e",
  null
  
)

export default component.exports